
export const UpdateStylesMixin = (SuperClass) => class extends SuperClass {

  updateStyles(propName, value, selector = this) {
    if(!this.isConnected) return;
    selector.style.setProperty(propName, value);
    if(window.ShadyCSS) window.ShadyCSS.styleSubtree(this, {[propName] : value});
  }

};